module.exports = __webpack_public_path__ + "img/63.304f55e1.png";